import { AppStructure } from './AppStructure';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { onError } from '@apollo/client/link/error';

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const link = from([
  errorLink,
  new HttpLink({
    uri: 'https://api.ampere.cloud/apollo-gateway',
  }),
]);

const authLink = setContext((_, { headers }) => {
  const token =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJlOVJobFpnSENpRjA0bnkyUnUzU0J6dFhCNkRocTY5YyIsImlhdCI6MTY4NjAzODM5NSwiZXhwIjoxNzE3NTk1OTk1fQ.uhTNEjlK-OceVw4O93zHod75IOQvxH2z99WqDQoLNow';
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`,
    },
  };
});

const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Facility: {
        merge: true,
      },
    },
  }),
  link: authLink.concat(link),
});

export function App() {
  return (
    <ApolloProvider client={client}>
      <AppStructure />
    </ApolloProvider>
  );
}
